import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "references-index-pane iodine-scrollable-y full-width" }
const _hoisted_2 = { class: "iodine-padding-md reference-index-container" }

import ReferencesSearch from 'components/references/ReferencesSearch.vue';
import ReferencesBrowse from 'components/references/ReferencesBrowse.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferencesIndex',
  props: {
    referencesOption: { default: 'search' }
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (props.referencesOption === 'browse')
        ? (_openBlock(), _createBlock(ReferencesBrowse, { key: 0 }))
        : _createCommentVNode("", true),
      (props.referencesOption === 'search')
        ? (_openBlock(), _createBlock(ReferencesSearch, { key: 1 }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})